import './topbar.css'

export default function TopBar(props) {

    return (
        <div className="top">
            <div className="topLeft">
                <img className="logo" src="./logo.png" alt="logo" />
            </div>
            <div className="topCenter">
                <form onSubmit={props.handleSubmitPage}>
                    <input type="text" className="topSearch" placeholder="Digite a Página" name="page"/>
                    <input type="submit" className="topSearchButton" value="Ir" />
                </form>
            </div>
            <div className="topRight">
                {props.admin 
                    ? <span className="user" onClick={props.handleLogoutClick} title="Sair">
                        <i className="fas fa-sign-out-alt"></i>
                      </span>
                    : <span className="user" onClick={props.handleLoginClick} title="Entrar">                    
                        <i className="fas fa-user"></i>
                      </span>
                }
            </div>
        </div>
    )
}
